import uuidv4 from "uuid/v4";
import h from "./h";
import utils from "./utils";

const vppCategories = [
  {
    id: uuidv4(),
    name: "Băng dính 2 mặt",
    donvi: "Cuộn",
    description: "5 cm",
    xuatxu: "Đài Loan",
    dongia: 8000
  },
  {
    id: uuidv4(),
    name: "Băng dính nhỏ",
    donvi: "Cuộn",
    description: "2 cm",
    xuatxu: "Đài Loan",
    dongia: 2500
  },
  {
    id: uuidv4(),
    name: "Băng dính to",
    donvi: "Cuộn",
    description: "5 cm",
    xuatxu: "Đài Loan",
    dongia: 12500
  }
];

const vanphongphamItems = [];

export default {

  approve(id) {
    return new Promise(resolve => {
      this.findById(id).then(response => {
        response.data.status = "approved";
        resolve();
      });
    });
  },

  delete(id) {
    return new Promise(resolve => {
      this.findById(id).then(response => {
        response.data.status = "deleted";
        resolve();
      });
    });
  },

  findVppCategoryId(id) {
    return Promise.resolve({
      data: h.find(vppCategories, item => item.id === id)
    });
  },

  findById(id) {
    return Promise.resolve({
      data: h.find(vanphongphamItems, item => item.id === id)
    });
  },

  getLimitTotal(deptId) {
    return 2000000;
  },

  getApprovedTotal(deptId) {
    let approvedTotal = 0;
    h.each(vanphongphamItems, item => {
      if (item.deptId === deptId && item.status === "approved") {
        approvedTotal += (item.total || 0);
      }
    })
    return approvedTotal;
  },

  searchCategories(query) {
    return Promise.resolve({
      data: h.findAll(vppCategories, item => {
        return !query || utils.like(item.name, query);
      })
    });
  },

  search_(items, searchForm) {
    return h.findAll(items, item => {
      return (
        (!searchForm.query || utils.like(item.title, searchForm.query)) &&
        (!searchForm.status || item.status === searchForm.status)
      );
    });
  },

  findAll(searchForm, pagable) {
    return Promise.resolve({
      data: this.search_(vanphongphamItems, searchForm).slice(
        pagable.page * pagable.size,
        (pagable.page + 1) * pagable.size - 1
      )
    });
  },

  insert(submitForm) {
    return new Promise(resolve => {
      vanphongphamItems.push({
        id: uuidv4(),
        title: submitForm.title,
        deptName: submitForm.deptName,
        deptId: submitForm.deptId,
        items: submitForm.items,
        total: submitForm.total,
        status: "waitForApproving",
      });
      resolve();
    });
  },

  update(id, submitForm) {
    return new Promise(resolve => {
      this.findById(id).then(response => {
        let item = response.data;
        item.title = submitForm.title;
        item.items = submitForm.items;
        item.total = submitForm.total;
        resolve();
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/vanphongphamService.js